module.exports = __webpack_public_path__ + "static/scale-model-of-river's-edge-in-springfield-massachusetts-8a7be0d07a5cbc3aeb9cc88e9c46cb35.png";